import { useQuery, type UseQueryResult } from "@tanstack/react-query"

import { PROPOSAL_KEYS } from "~/api/cache"

import type { PowurOsPricingDto } from "../dto/proposal.dto"
import { ProposalService } from "../services/proposal.service"

const proposalService = new ProposalService()

export function useFetchProposalPricingComparisons(
  proposalId: string,
  requestedMargins: number[],
): UseQueryResult<PowurOsPricingDto[], unknown> {
  return useQuery({
    queryKey: PROPOSAL_KEYS.pricingComparisons(proposalId, requestedMargins),
    queryFn: () =>
      proposalService.fetchProposalPricingComparisons(
        proposalId,
        requestedMargins,
      ),
    enabled: requestedMargins.length > 0,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
